import React from "react";

const ChillerTruckPricing = ({ title, description, tableLabel, rows }) => {
  return (
    <section className="ct-pricing-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
          <p>{description}</p>
        </div>

        {tableLabel && (
          <h3
            className="ct-table-subtitle mb-3"
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-once="true"
          >
            {tableLabel}
          </h3>
        )}

        <div
          className="table-responsive"
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-once="true"
        >
          <table className="ct-pricing-table">
            <thead>
              <tr>
                <th>Tonnage Tier</th>
                <th>Daily Without Driver</th>
                <th>Daily With Driver</th>
                <th>Weekly</th>
                <th>Monthly</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i}>
                  <td><strong>{row.tier}</strong></td>
                  <td>{row.dailyWithout}</td>
                  <td>{row.dailyWith}</td>
                  <td>{row.weekly}</td>
                  <td>{row.monthly}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </section>
  );
};

export default ChillerTruckPricing;
